import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Success Toast
export const successToast = (message = "Success!") => {
    toast.success(message, {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "custom-toast-success", // Add a custom class if needed
    });
};

// Error Toast
export const errorToast = (message = "Something went wrong!") => {
    toast.error(message, {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "custom-toast-error", // Add a custom class if needed
    });
};
